import axios from "axios";
import { TTP_API_URL, SETTINGS_USERS_PAGE_LIMIT } from "Config";
import { /*updateSourceToken,*/ throwCatchedError } from "Utils";

export const getAvatarsAndUsers = (
  token,
  word,
  organizationId,
  sourceToken = null
) => {
  // getAvatarsAndUsersSourceToken = updateSourceToken(
  //   getAvatarsAndUsersSourceToken,
  //   sourceToken
  // );

  const fields = [
    "*",
    "mediaAvatar",
    "email",
    "avatar",
    "blogRoleInOrganization",
    "role",
    "defaultSignature"
  ];

  let requestUrl = `${TTP_API_URL}/blog/avatar/avatars-and-users`;

  let filter = [];

  if (word !== "" && word.length >= 3) {
    filter.push({
      property: "name",
      value: word,
      operator: "like"
    });
  }

  let params = {
    access_token: token,
    filter: JSON.stringify(filter),
    fields: fields.join(","),
    limit: 5,
    start: 0,
    organization_id: organizationId
  };

  return axios
    .get(requestUrl, {
      // cancelToken: getAvatarsAndUsersSourceToken.token,
      params: params
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};

export const getUsersSettings = (
  token,
  page,
  word,
  role,
  organizationId,
  sourceToken = null
) => {
  // getUsersSettingsSourceToken = updateSourceToken(
  //   getUsersSettingsSourceToken,
  //   sourceToken
  // );

  const fields = [
    "*",
    "email",
    "avatar",
    "blogRoleInOrganization",
    "role",
    "defaultSignature",
    "communities"
  ];

  let roleGroup = "2";
  if (role !== "ALL") {
    roleGroup = role.slice(0, 1);
    role = role.slice(1);
  }

  let requestUrl = `${TTP_API_URL}/media/media-settings/media-setting-users`;

  if (roleGroup === "1" || roleGroup === "0") {
    requestUrl = `${TTP_API_URL}/organization/user`;
  }

  // let requestUrl =
  //   `${TTP_API_URL}/organization/user` +
  //   (roleGroup === "1" || roleGroup === "0"
  //     ? ""
  //     : "/blog-setting-users?type=BLOG");

  let filter = [];

  if (parseInt(roleGroup, 10) === 0) {
    requestUrl += "/get-user-by-state";
    if (role === "ACTIVE") {
      requestUrl += "?active=1";
    } else if (role === "NOT_ACTIVE") {
      requestUrl += "?active=0";
    }
    if (word !== "" && word.length >= 3) {
      requestUrl += "&name=" + word;
    }
  } else if (parseInt(roleGroup, 10) === 1) {
    filter.push({
      property: "role.type",
      value: role,
      operator: "eq"
    });
  } else {
    if (role !== "ALL") {
      requestUrl += "&blogRole=" + role;
    }
  }
  if (word !== "" && word.length >= 3) {
    filter.push({
      property: "name",
      value: word,
      operator: "like"
    });
  }

  let params = {
    access_token: token,
    filter: JSON.stringify(filter),
    fields: fields.join(","),
    limit: SETTINGS_USERS_PAGE_LIMIT,
    start: page * SETTINGS_USERS_PAGE_LIMIT,
    organization_id: organizationId
  };

  return axios
    .get(requestUrl, {
      // cancelToken: getUsersSettingsSourceToken.token,
      params: params
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};

export const saveUsersSettings = ({
  token,
  usersIds,
  community,
  languages,
  types
}) => {
  var formData = new FormData();

  const requestUrl = `${TTP_API_URL}/media/media-settings/media-settings?access_token=${token}`;

  for (let userId of usersIds) {
    formData.append("usersId[]", userId);
  }

  formData.append("communityId", community.id);
  formData.append("languages", languages.join(","));
  formData.append("roles[imageRole]", types["IMAGE"]);
  formData.append("roles[videoRole]", types["VIDEO"]);
  formData.append("roles[pdfRole]", types["PDF"]);
  formData.append("roles[pptRole]", types["PPT"]);

  return axios.post(requestUrl, formData);
};

export const saveGeneralSettings = ({
  token,
  community,
  languages,
  generalTypes,
  defaultData,
  publicProfile
}) => {
  var formData = new FormData();

  const requestUrl = `${TTP_API_URL}/media/media-settings/general-settings?access_token=${token}`;

  formData.append("communityId", community.id);
  formData.append("languages", languages.join(","));
  formData.append("generalTypes", generalTypes.join(","));
  formData.append("publicProfile", publicProfile ? 1 : 0);
  formData.append("defaultData", JSON.stringify(defaultData));

  return axios.post(requestUrl, formData);
};

export const saveUserAvatarToApi = (token, userId, avatar, rect) => {
  const requestUrl = `${TTP_API_URL}/organization/user/upload/profileAvatarForUser?access_token=${token}`;

  var formData = new FormData();

  formData.append("userId", userId);
  formData.append("profile_avatar", avatar);

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/user.js